import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RequestService} from 'src/app/data/handlers/request/request.service';
import {globalEnv} from '../../connection/global/global.env';
import {GetCustomerExpressResponse, iUpdateUserExpress} from '../../models/express-store-registration/express-store-registration';
import {customer} from '../../api/customer/customer.api';
import { SetCountryService } from 'src/app/data/utils/set-country.service';

@Injectable({
  providedIn: 'root',
})
export class ExpressStoreRegistrationService {
  constructor(private req: RequestService,private setCountryService: SetCountryService) {}

  getCustomerExpress(params): Observable<GetCustomerExpressResponse> {
    const endPoint = this.setCountryService.changeUrl(customer.get);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, params, null, null, false);
  }

  updateCustomerExpress(data, customerRef, selfCheckout): Observable<iUpdateUserExpress> {
    const headers = selfCheckout ? {'SELF-CHECKOUT': 'true', SOURCE: 'WEB'} : null;

    const url = `${globalEnv.multiCountry}${customer.updateUserExpress}${customerRef}`;
    return this.req.put(url, data, null, null, false, false, null, headers, true);
  }
}
